import script from "./AdminMenuComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminMenuComponent.vue?vue&type=script&setup=true&lang=ts"

import "./AdminMenuComponent.vue?vue&type=style&index=0&id=da585a22&lang=css"

const __exports__ = script;

export default __exports__